<template>
    <div class="header-wrapper">
      <div class="center-wrapper">
        <header class="header">
          <router-link :to="{ name: 'home' }" class="header__logo">
            <img alt="Медстрим онлайн" src="/images/ui/logo.png" />
          </router-link>

          <ul class="header__partners">
            <li v-for="partner in partners" class="header__partner">
              <img class="header__partner-logo" :alt="partner.title" :src="'/images/partners/' + partner.id + '/' + partner.logo" />
            </li>
          </ul>
          <div class="header__empty"></div>

          <ul class="header__auth authblock">
            <!-- Authenticated -->
            <li v-if="user" class="authblock__item authblock__item-user userblock">
              <div class="userblock__card usercard">
                <router-link :to="{ name: 'settings.profile' }">
                  <span class="usercard__item usercard__item-profile">{{ user.name }}</span>
                </router-link>

                <a @click.prevent="logout" class="usercard_item usercard__item-logout" href="#">
                  Выйти
                </a>
              </div>
              <div class="userblock__card userimage">
                <img :src="user.photo_url" class="rounded-circle profile-photo mr-1">
              </div>
            </li>
            <!-- Guest -->
            <li class="authblock__item authblock__item-login entrance" v-else>
              <button @click="showUniversalModal()" class="entrance__button entrance__button-login button button-blue">
                Войти
              </button>
            </li>
          </ul>
        </header>

        <ul class="breadcrumbs">
          <li class="breadcrumbs__item" v-for="breadcrumb in breadcrumbs">
            <router-link :to="breadcrumb.route" class="breadcrumbs__link">
              {{ breadcrumb.title }}
            </router-link>
          </li>
          <li class="breadcrumbs__item breadcrumbs__item--current" v-if="currentPageTitle">
            {{ currentPageTitle.title }}
          </li>
        </ul>
      </div>

      <universal-modal :show.sync="universalModal" @close="closeUniversalModal()"></universal-modal>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import LocaleDropdown from './LocaleDropdown';
import UniversalModal from './UniversalModal';

export default {
  data: () => ({
    appName: window.config.appName,
    fromAdmin: false,
  }),
  computed: {
    ...mapGetters({
      user: 'auth/user',
      pageInfo: 'pages/pageInfo',
      appTitle: 'common/title',
      universalModal: 'modals/universal',
      breadcrumbs: 'pages/breadcrumbs',
      currentPageTitle: 'pages/currentPageTitle'
    }),
    partners: function () {
      return this.pageInfo ? this.pageInfo.partners : [];
    },
    isAdmin: function () {
      return this.user && this.user.roles.indexOf('admin') !== -1;
    },
    isCurator: function () {
      return this.user && this.user.roles.indexOf('curator') !== -1;
    },
    isTeacher: function () {
      return this.user && this.user.roles.indexOf('teacher') !== -1;
    }
  },
  components: {
    LocaleDropdown,
    UniversalModal,
  },
  methods: {
    showUniversalModal () {
      this.$store.dispatch('modals/showLogin');
    },
    closeUniversalModal () {
      this.$store.dispatch('modals/closeLogin');
    },
    async logout () {
      await this.$store.dispatch('auth/logout');
      this.$router.push({ name: 'home' });
    },
  },
  beforeMount () {
    this.$store.dispatch('modals/initLogin');
  },
  created () {
  },
  beforeDestroy () {
  },
};
</script>
